import { X } from "@phosphor-icons/react";
import { t } from "i18next";
import React, { MouseEventHandler, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

interface Context {
  showModal: boolean;
  setShowModal: (showModal: boolean) => MouseEventHandler;
  loading: boolean;
  showFooter?: boolean;
}

interface ModalConfig {
  title: string;
  contextInstance: any;
  onSubmit?: any;
  customShowModal?: boolean;
  customSetShowModal?: any;
  size?: string;
  fullscreen?: any;
  detectChanges?: boolean; // Nuevo parámetro
}
interface Props {
  modalConfig: ModalConfig;
  children: React.ReactNode; // para el body
  leftButtons?: React.ReactNode; // para los botones a la izquierda del footer
}

function CrudModuleFactoryModal(props: Props) {
  const {
    title,
    contextInstance,
    onSubmit,
    customShowModal,
    customSetShowModal,
    size,
    fullscreen,
    detectChanges = false,
  } = props.modalConfig;

  const { children, leftButtons } = props;
  const { showModal, setShowModal, loading, showFooter } = contextInstance;

  const { changed, showModal: showConfirmModal } = useContext(ChangeDectionContext);

  const handleClose = () => {
    if (detectChanges && changed) {
      showConfirmModal(
        () => {
          if (customSetShowModal) {
            customSetShowModal(false);
          } else {
            setShowModal(false);
          }
        },
        () => console.log("Cancelación del cierre")
      );
      return;
    }

    if (customSetShowModal) {
      customSetShowModal(false);
      return;
    }
    setShowModal(false);
  };

  const onSubmitFunction = () => {
    onSubmit();
  };

  const showModalValue = customShowModal != undefined ? customShowModal : showModal;

  return (
    <Modal
      show={showModalValue}
      onHide={handleClose}
      className={size}
      fullscreen={fullscreen}
    >
      <Modal.Header>
        <Modal.Title as="div">{t(title)}</Modal.Title>
        <a href="javascript:;" onClick={handleClose}>
          <X className="ms-3 me-2 text-white" />
        </a>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {showFooter ||
        (showFooter === undefined && (
          <Modal.Footer className="d-flex justify-content-between">
            <div>
              {/* Aquí renderizamos los botones adicionales a la izquierda */}
              {leftButtons}
            </div>
            <div>
              {/* Botones por defecto a la derecha */}
              <Button variant="outline-dark" onClick={handleClose}>
                {t("close")}
              </Button>
              <Button variant="primary" disabled={loading} onClick={onSubmitFunction}>
                {t("save_changes")}
              </Button>
            </div>
          </Modal.Footer>
        ))}
    </Modal>
  );
}

export default CrudModuleFactoryModal;
